(function searchAdditionalActions() {
    let searchInputWrap = document.querySelector('.search-input');
    let searchInput = document.querySelector('.searchForm__input');
    let predictiveSearch = document.querySelector('.predictive-search');
    let clearSearch = document.querySelector('.searchClear');

    searchInput.addEventListener('keydown', function (e) {
        e.target.parentNode.classList.add('search-input--typing');
        predictiveSearch.classList.add('active');
        predictiveSearch.classList.remove('hidden-search');
        clearSearch.classList.remove('hidden-search');
    });

    clearSearch.addEventListener('click', function (e) {
        searchInputWrap.classList.remove('search-input--typing');
        predictiveSearch.classList.remove('active');
        clearSearch.classList.remove('hidden-search');
    });

    searchInput.addEventListener('keyup', function (e) {
        if (document.querySelector('.searchForm__input').value === '') {
            searchInputWrap.classList.remove('search-input--typing');
            predictiveSearch.classList.remove('active');
            clearSearch.classList.remove('hidden-search');
        }
    });

    document.addEventListener('click', function (e) {
        if ($(e.target).parent().attr('class') && !$(e.target).parent().attr('class').match(/search-input|searchForm|predictive-search__tab-item/)) {
            searchInputWrap.classList.remove('search-input--typing');
            predictiveSearch.classList.remove('active');
            clearSearch.classList.add('hidden-search');
            predictiveSearch.classList.add('hidden-search');
        }
    });
})();
